var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_303_2828",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_303_2828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 9.33334C7.72933 9.33334 8.34912 9.07814 8.85954 8.56772C9.36995 8.0573 9.62516 7.43751 9.62516 6.70834C9.62516 5.97918 9.36995 5.35939 8.85954 4.84897C8.34912 4.33855 7.72933 4.08334 7.00016 4.08334C6.271 4.08334 5.6512 4.33855 5.14079 4.84897C4.63037 5.35939 4.37516 5.97918 4.37516 6.70834C4.37516 7.43751 4.63037 8.0573 5.14079 8.56772C5.6512 9.07814 6.271 9.33334 7.00016 9.33334ZM7.00016 8.28334C6.56266 8.28334 6.19079 8.13022 5.88454 7.82397C5.57829 7.51772 5.42516 7.14584 5.42516 6.70834C5.42516 6.27084 5.57829 5.89897 5.88454 5.59272C6.19079 5.28647 6.56266 5.13334 7.00016 5.13334C7.43766 5.13334 7.80954 5.28647 8.11579 5.59272C8.42204 5.89897 8.57516 6.27084 8.57516 6.70834C8.57516 7.14584 8.42204 7.51772 8.11579 7.82397C7.80954 8.13022 7.43766 8.28334 7.00016 8.28334ZM7.00016 11.0833C5.58072 11.0833 4.28766 10.6872 3.121 9.8948C1.95433 9.10244 1.1085 8.04029 0.583496 6.70834C1.1085 5.3764 1.95433 4.31425 3.121 3.52189C4.28766 2.72952 5.58072 2.33334 7.00016 2.33334C8.41961 2.33334 9.71266 2.72952 10.8793 3.52189C12.046 4.31425 12.8918 5.3764 13.4168 6.70834C12.8918 8.04029 12.046 9.10244 10.8793 9.8948C9.71266 10.6872 8.41961 11.0833 7.00016 11.0833ZM7.00016 9.91668C8.09877 9.91668 9.10745 9.62744 10.0262 9.04897C10.945 8.4705 11.6474 7.69029 12.1335 6.70834C11.6474 5.7264 10.945 4.94619 10.0262 4.36772C9.10745 3.78925 8.09877 3.50001 7.00016 3.50001C5.90155 3.50001 4.89287 3.78925 3.97412 4.36772C3.05537 4.94619 2.35294 5.7264 1.86683 6.70834C2.35294 7.69029 3.05537 8.4705 3.97412 9.04897C4.89287 9.62744 5.90155 9.91668 7.00016 9.91668Z",
    fill: "#000A8C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.29fe1478.svg";
export { ForwardRef as ReactComponent };